module.exports = {"id":"208053","name":"Dimitrios Pelkas","rating":"74","photo":"./data/images/photos/3/208053.png","club":{"name":"PAOK Salonique","logo":"./data/images/clubs/PAOKSalonique.png"},"positions":["MOC","MD","MG","MC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DimitriosPelkas0.json
// module id = 1107
// module chunks = 0